// extracted by mini-css-extract-plugin
export var wordContainer = "_r9-0";